
  import { mapState } from 'vuex'
  export default {
    name: 'Theme2MissionMobileVipTierCard',
    props: {
      displayTierTitle: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      ...mapState({
        vipTiers: state => state.activities['vip-system'].vipTiers,
        vipSystem: state => state.activities['vip-system'].vipSystem
      }),
      tiersList() {
        if (this.vipTiers?.tiers?.length)
          return this.vipTiers.tiers?.filter(el => el.tier_type === 1)
        return []
      }
    }
  }
